<template>
    <div class="container">
        <div class="row">
            <div class="twelve columns">
                <h2>Register</h2>
            </div>
        </div>
        <div class="row">
            <div class="six columns"><label>Kind of Credential</label></div>
            <div class="six columns">
                <select v-model="myKindofCredential">
                    <option disabled value="">Please select one</option>
                    <option value="password">Account / Password</option>
                    <option value="fido2">FIDO-2 authenticator</option>
                </select>
            </div>
        </div>
        <div v-if="myKindofCredential!==''" class="row">
            <div class="six columns"><label>Account <small>(eMail)</small></label></div>
            <div class="six columns"><input type="email" v-model="myAccount"></div>
        </div>
        <div v-if="myKindofCredential!==''" class="row">
            <div class="six columns"><label>Display Name</label></div>
            <div class="six columns"><input type="text" v-model="myDisplayName"></div>
        </div>
        <div v-if="myKindofCredential==='password'" class="row">
            <div class="six columns"><label>Password</label></div>
            <div class="six columns"><input type="password" v-model="myPasswd" autocomplete="false"></div>
        </div>
        <div v-if="myKindofCredential!==''" class="row">
            <div class="six columns">&nbsp;</div>
            <div class="six columns"><button @click="runRegister" class="button button-primary">Register</button></div>
        </div>
    </div>
</template>

<script>
import { registerNewUser } from '../services/helper-fido2.js'
export default {
    name: 'PageRegister',
    data: function () {
        return {
            myKindofCredential: '',
            myAccount: '',
            myDisplayName: '',
            myPasswd: ''
        }
    },
    methods: {
        runRegister: function (/* event */) {
            let userDetails = {
                kindOfCredential: this.myKindofCredential,
                user: this.myAccount,
                displayName: this.myDisplayName
            }
            if (this.myKindofCredential === 'password') {
                userDetails.password = this.myPasswd
            }

            registerNewUser(userDetails)
                .then(data => {
                    console.log(`PageRegister.runRegister.THEN: data:`, data)
                })
                .catch(err => {
                    console.error(`PageRegister.runRegister.CATCH: err:`, err)
                })
        }
    }
}
</script>

<style scoped>
    input { color: #333333; width: 100%; }
    select { color: #333333; }
</style>



// WEBPACK FOOTER //
// src/components/pages/PageRegister.vue